function getCompanyCode(): string {
    if (!localStorage.getItem('companyCode')) {
        return ""
    }
    return localStorage.getItem('companyCode') || ""
}

export default getCompanyCode